export class HomeIntroductionPanelModule {

    constructor() {
        this.init();
    }

    navigation() {

        $(".js-home-introduction--menu-item").on('click', function (e) {
            e.preventDefault();
            var panelRqst = $(this)[0].getAttribute("value");
            $("#component-home-introduction--home").hide();
            $("#component-home-introduction--block-1").hide();
            $("#component-home-introduction--block-2").hide();
            $("#component-home-introduction--block-3").hide();
            $("#" + panelRqst).show();
        });

        $("#component-home-introduction").on('click', '.js-home-introduction__panel', function (e) {
            e.preventDefault();
            var panelRqst = $(this).data("value");
            $("#component-home-introduction--home").hide();
            $("#" + panelRqst).show();
        });

    }

    resetClick() {

        $("#component-healthcare-home-introduction-reset").on("click", function (e) {

            e.preventDefault();

            $("#component-home-introduction-postcode").val("");

            $("#hospitalDropdown .dropdown-toggle:first-child").text("Hospital");
            $("#hospitalDropdown .dropdown-toggle:first-child").val("");

            $("#treatmentDropdown .dropdown-toggle:first-child").text("Treatment");
            $("#treatmentDropdown .dropdown-toggle:first-child").val("");

            $("#specialityDropdown .dropdown-toggle:first-child").text("Speciality");
            $("#specialityDropdown .dropdown-toggle:first-child").val("");

            $("#component-home-introduction-treatment").prop("checked", true);
            $("#specialityDropdown").hide();
            $("#treatmentDropdown").show();

        });

    }

    searchClick() {

        var that = this;
        $("#component-healthcare-home-introduction-search").on("click", function (e) {

            //console.log("component-home-introduction-search - clicked");
            e.preventDefault();

            var url = $("#component-healthcare-home-introduction--consultant").data("navigation-url");
            var filterString = "?filterByTreatment=&filterBySpecialty=";
            var consultantRadioButtonValue = $("input[name='hospital-search']:checked").val();

            if (consultantRadioButtonValue == "treatment") {
                var val = $("#treatmentDropdown .dropdown-toggle:first-child").val();
                filterString = "?filterByTreatment=" + val + "&filterBySpecialty=";
            }
            else if (consultantRadioButtonValue == "speciality") {
                var val = $("#specialityDropdown .dropdown-toggle:first-child").val();
                filterString = "?filterByTreatment=&filterBySpecialty=" + val;
            }
            var hosVal = $("#hospitalDropdown .dropdown-toggle:first-child").val();
            var postcode = $("#component-home-introduction-postcode").val();

            filterString += "&filterByHospital=" + hosVal;
            filterString += "&filterByName=&filterByPostCode=" + postcode + "&filterByBookable=false";

            if (url === undefined) {
                url = "/consultants/profiles/";
            }


            that.SetMap(postcode);
            //    alert(that.hospitalIds + ' h i');
            //    url += "&filterByHospital=" + that.hospitalIds;
            //    alert(url);

            //console.log("component-home-introduction-URL - " + url + filterString);
            //console.log("component-home-introduction-URL - " + url + filterString);
            window.location = url + filterString;
        });

        //$(".js-consultant-search-form-submit").on('click', function (e) {
        //    e.preventDefault();

        //    var $form = $("#consultantSearchForm"),
        //        filterConsultantType = $form.find("input:radio[name=filterConsultantType]:checked").val(),
        //        filterTreatmentSpeciality = $form.find("#treatmentSpecialitySearch").val(), // Might need to tell results page if speciality or treatment
        //        filterLocation = $form.find("#location-finder").val(),
        //        filterName = $form.find("#nameSearch").val(),
        //        url = $form.attr("action");
        //    //   var locationSuggested = this.SetMap(filterLocation);
        //    url += "?filterConsultantType=" + filterConsultantType + "&filterTreatmentSpeciality=" + filterTreatmentSpeciality
        //        + "&filterLocation=" + filterLocation + "&filterName=" + filterName;

        //    //if (filterLocation != '') {

        //    //    url += "&filterByHospital=" + that.SetMap(filterLocation);

        //    //}

        //    $form.attr('action', url).submit();

        //});

    }

   

    SetMap(postcode) {
        var that = this;
        if (postcode != '') {
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({ 'address': postcode }, function (results, status) {

                if (status == google.maps.GeocoderStatus.OK) {
                    that.lat = results[0].geometry.location.lat();
                    that.lng = results[0].geometry.location.lng();

                    $.ajax({
                        type: "POST",
                        url: apilocation + 'EnquiryFormApi/NearestHospitalList',
                        data: JSON.stringify({ "postcode": postcode }),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json"
                    }).done(function (data) {

                        if (data.length > 0) {
                            // alert(data)
                            that.hospitalIds = data;
                        }

                    });

                }

            });
        }
        // alert(that.hospitalIds);
        return that.hospitalIds;

    }


    init() {
        var that = this;
        // $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyALpZboQbieD8FePSqE0JK2LdTvHlnAZy4&libraries=places', function () { that.SetMap($('#location-finder').val()); });
        $('.home-introduction-healthcare--content').find('li').find('a').on("click", function (e) {
            if ($(this).text() == "NHS referrals") {
               
                $(this).attr("href", $(this).attr("href") + "?scroll=bottom");
             
            }

        });
        this.navigation();
        this.searchClick(); 
        this.resetClick();

       

    }

}